export default __webpack_public_path__ + "static/datadriven-gradient-fdc51c6ef7c07092dfe38231666a3c7a.svg";